var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { getTerritoryReportService } from "../../services/apiServices/salesRepDataService";
import { getCountryCenter, getDefaultDateRange, buildHashmaps, resolveMarkerCoords, } from "./TerritoryReportsUtils";
import { formatAmount } from "../../shared/Utilites";
export function TerritoryReportsBL() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f;
    var dispatch = useDispatch();
    var salesRepData = useSelector(function (state) { return state.salesRepData; });
    var reduxRawRows = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.territoryReportData) !== null && _a !== void 0 ? _a : null;
    var shopCurrency = (_c = (_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.shopCurrency) !== null && _c !== void 0 ? _c : "";
    var currency = (_e = (_d = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.loggedInRepDetails) === null || _d === void 0 ? void 0 : _d.currency) !== null && _e !== void 0 ? _e : "";
    var defaultRange = getDefaultDateRange();
    var _g = useState(defaultRange), dateRange = _g[0], setDateRange = _g[1];
    var _h = useState("1month"), selectedPresetKey = _h[0], setSelectedPresetKey = _h[1];
    var _j = useState(false), isFetching = _j[0], setIsFetching = _j[1];
    var _k = useState([]), drillPath = _k[0], setDrillPath = _k[1];
    var _l = useState(""), searchText = _l[0], setSearchText = _l[1];
    var _m = useState(false), repModalOpen = _m[0], setRepModalOpen = _m[1];
    var _o = useState([]), repModalNames = _o[0], setRepModalNames = _o[1];
    var _p = useState(null), hoveredKey = _p[0], setHoveredKey = _p[1];
    var activeHashmaps = useMemo(function () {
        if (!reduxRawRows || reduxRawRows.length === 0)
            return null;
        return buildHashmaps(reduxRawRows);
    }, [reduxRawRows]);
    var fetchTerritoryData = useCallback(function (startDate, endDate) { return __awaiter(_this, void 0, void 0, function () {
        var response, rows, action;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsFetching(true);
                    return [4 /*yield*/, getTerritoryReportService(startDate, endDate)];
                case 1:
                    response = _c.sent();
                    setIsFetching(false);
                    if (!response)
                        return [2 /*return*/];
                    rows = (_b = (_a = response === null || response === void 0 ? void 0 : response.territoryOrders) !== null && _a !== void 0 ? _a : response) !== null && _b !== void 0 ? _b : [];
                    action = {
                        payload: rows,
                        type: SalesRepDataActionType.TERRITORY_REPORT_DATA,
                    };
                    dispatch(action);
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    useEffect(function () {
        fetchTerritoryData(defaultRange.startDate, defaultRange.endDate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchTerritoryData]);
    var handleDateRangeApply = function (range, presetKey) {
        setDateRange(range);
        setSelectedPresetKey(presetKey);
        setDrillPath([]);
        setSearchText("");
        fetchTerritoryData(range.startDate, range.endDate);
    };
    var currentLevelRows = useMemo(function () {
        if (!activeHashmaps)
            return [];
        var prefix = drillPath.join("||");
        if (drillPath.length === 0) {
            return Object.entries(activeHashmaps.byCountry).map(function (_a) {
                var key = _a[0], stats = _a[1];
                return ({ label: key, key: key, stats: stats });
            });
        }
        if (drillPath.length === 1) {
            return Object.entries(activeHashmaps.byState)
                .filter(function (_a) {
                var key = _a[0];
                return key.startsWith(prefix + "||");
            })
                .map(function (_a) {
                var key = _a[0], stats = _a[1];
                return ({ label: key.split("||")[1], key: key, stats: stats });
            });
        }
        if (drillPath.length === 2) {
            return Object.entries(activeHashmaps.byCity)
                .filter(function (_a) {
                var key = _a[0];
                return key.startsWith(prefix + "||");
            })
                .map(function (_a) {
                var key = _a[0], stats = _a[1];
                return ({ label: key.split("||")[2], key: key, stats: stats });
            });
        }
        return Object.entries(activeHashmaps.byZip)
            .filter(function (_a) {
            var key = _a[0];
            return key.startsWith(prefix + "||");
        })
            .map(function (_a) {
            var key = _a[0], stats = _a[1];
            return ({ label: key.split("||")[3], key: key, stats: stats });
        });
    }, [activeHashmaps, drillPath]);
    var filteredRows = useMemo(function () {
        var lower = searchText.toLowerCase();
        var rows = searchText.trim()
            ? currentLevelRows.filter(function (_a) {
                var label = _a.label;
                return label.toLowerCase().includes(lower);
            })
            : currentLevelRows;
        return __spreadArray([], rows, true).sort(function (a, b) {
            if (a.label === "NA")
                return 1;
            if (b.label === "NA")
                return -1;
            return a.label.localeCompare(b.label);
        });
    }, [currentLevelRows, searchText]);
    var columnHeader = (_f = ["Country", "States", "City", "Postal Code"][drillPath.length]) !== null && _f !== void 0 ? _f : "Country";
    var isLastLevel = drillPath.length === 3;
    var handleDrillDown = function (key) {
        if (isLastLevel)
            return;
        var segment = key.split("||")[drillPath.length];
        setDrillPath(__spreadArray(__spreadArray([], drillPath, true), [segment], false));
        setSearchText("");
    };
    var handleBreadcrumbClick = function (targetLength) {
        setDrillPath(drillPath.slice(0, targetLength));
        setSearchText("");
    };
    var handleRepModalOpen = function (stats) {
        setRepModalNames(stats.salesRepNames);
        setRepModalOpen(true);
    };
    // Map uses the longest NA-free prefix of drillPath so clicking an NA row
    // does not move or zoom the map (NA has no valid coordinates).
    var mapDrillPath = useMemo(function () {
        var result = [];
        for (var _i = 0, drillPath_1 = drillPath; _i < drillPath_1.length; _i++) {
            var segment = drillPath_1[_i];
            if (segment === "NA")
                break;
            result.push(segment);
        }
        return result;
    }, [drillPath]);
    var mapMarkers = useMemo(function () {
        var _a;
        if (!activeHashmaps)
            return [];
        var source;
        if (mapDrillPath.length === 0) {
            source = activeHashmaps.byCountry;
        }
        else if (mapDrillPath.length === 3) {
            source = activeHashmaps.byCity;
        }
        else {
            var maps = [activeHashmaps.byCountry, activeHashmaps.byState, activeHashmaps.byCity, activeHashmaps.byZip];
            source = (_a = maps[mapDrillPath.length]) !== null && _a !== void 0 ? _a : activeHashmaps.byCountry;
        }
        return Object.entries(source)
            .filter(function (_a) {
            var key = _a[0];
            if (key.split("||").some(function (p) { return p === "NA"; }))
                return false;
            if (mapDrillPath.length === 0)
                return true;
            if (mapDrillPath.length === 3)
                return key === mapDrillPath.join("||");
            return key.startsWith(mapDrillPath.join("||") + "||");
        })
            .map(function (_a) {
            var key = _a[0], stats = _a[1];
            var labelIndex = mapDrillPath.length === 3 ? 2 : mapDrillPath.length;
            var label = key.split("||")[labelIndex];
            if (searchText.trim() && !label.toLowerCase().includes(searchText.toLowerCase()))
                return null;
            var coordinates = resolveMarkerCoords(mapDrillPath.length === 3 ? mapDrillPath.slice(0, 2) : mapDrillPath, label);
            return { key: key, label: label, stats: stats, coordinates: coordinates };
        })
            .filter(function (m) {
            return m !== null && m.coordinates !== null;
        });
    }, [activeHashmaps, mapDrillPath, searchText]);
    var mapConfig = useMemo(function () {
        var _a, _b;
        if (mapDrillPath.length === 0)
            return { center: [0, 20], zoom: 2 };
        var center = (_a = getCountryCenter(mapDrillPath[0])) !== null && _a !== void 0 ? _a : [0, 20];
        var zoomLevels = [2, 4, 6, 8];
        return { center: center, zoom: (_b = zoomLevels[mapDrillPath.length]) !== null && _b !== void 0 ? _b : 4 };
    }, [mapDrillPath]);
    return {
        isFetching: isFetching,
        drillPath: drillPath,
        searchText: searchText,
        setSearchText: setSearchText,
        filteredRows: filteredRows,
        columnHeader: columnHeader,
        isLastLevel: isLastLevel,
        handleDrillDown: handleDrillDown,
        handleBreadcrumbClick: handleBreadcrumbClick,
        handleRepModalOpen: handleRepModalOpen,
        repModalOpen: repModalOpen,
        setRepModalOpen: setRepModalOpen,
        repModalNames: repModalNames,
        hoveredKey: hoveredKey,
        setHoveredKey: setHoveredKey,
        dateRange: dateRange,
        selectedPresetKey: selectedPresetKey,
        handleDateRangeApply: handleDateRangeApply,
        mapMarkers: mapMarkers,
        mapConfig: mapConfig,
        shopCurrency: shopCurrency,
        currency: currency,
        activeHashmaps: activeHashmaps,
        formatAmount: formatAmount,
    };
}
